type AvatarProps = {
  userId: string | null;
  label: string | null;
  size?: number;
  className?: string;
};

export function Avatar({ userId, label, size = 40, className = "" }: AvatarProps) {
  const initials = initialsFor(label);
  const bg = userId ? hashedColor(userId) : "rgba(137, 149, 186, 0.4)";
  return (
    <div
      style={{
        width: size,
        height: size,
        backgroundColor: bg,
      }}
      className={`flex items-center justify-center rounded-full text-xs font-semibold text-fg ${className}`}
    >
      {initials}
    </div>
  );
}

function initialsFor(label: string | null): string {
  if (!label) return "?";
  const parts = label.trim().split(/\s+/).slice(0, 2);
  return parts.map((p) => p[0]?.toUpperCase() ?? "").join("") || "?";
}

function hashedColor(seed: string): string {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) | 0;
  const palette = [
    "rgba(34,255,95,0.25)",
    "rgba(0,227,253,0.22)",
    "rgba(255,186,32,0.22)",
    "rgba(132,149,128,0.30)",
    "rgba(218,226,253,0.18)",
  ];
  return palette[Math.abs(h) % palette.length];
}
